export const wakLogin = (
  username: string,
  password: string,
  expires = 3600,
): Promise<Response> => {
  // note: no "unauthorized" event on login
  return fetch(
    `${process.env.REACT_APP_API_HOST ?? '127.1'}/rest/$directory/login`,
    {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify([username, password, expires]),
    },
  );
};

export const wakLogout = (): Promise<Response> => {
  return fetch(
    `${process.env.REACT_APP_API_HOST ?? '127.1'}/rest/$directory/logout`,
    {
      method: 'GET',
      credentials: 'include',
    },
  );
};

export const wakHandleRequest = async (
  table: string,
  method: string,
  parameters: object = {},
): Promise<Response> => {
  const res = await fetch(
    `${process.env.REACT_APP_API_HOST ?? '127.1'}/rest/Utils/handleRequest`,
    {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify([table, method, parameters]),
    },
  );

  if (res.status === 401) {
    window.dispatchEvent(new Event('unauthorized'));
  }

  return res;
};
